import _ from 'lodash';
import moment from 'moment';
import { isEmpty } from 'ramda';

export function getValidDestinationsAndPlaceholderValue(destinations) {
  return destinations
    .filter(({ isValueFromSuggestion }) => isValueFromSuggestion)
    .concat([{}]);
}

export function getValidTravellersAndPlaceholderValue(travellers, appendEmptyObject = true) {
  const validTravellers = travellers
    .filter(({ relationship }) => relationship && !isEmpty(relationship));

  return appendEmptyObject ? validTravellers.concat([{}]) : validTravellers;
}

export function getValidTravellersAndPlaceholderValueAfterDelete(travellers) {
  return travellers
    .filter(({ relationship }) => !_.isEmpty(relationship))
    .filter(({ dateOfBirth }) => !_.isEmpty(dateOfBirth))
    .filter(({ dateOfBirthValid }) => dateOfBirthValid === true)
    .concat([{}]);
}

export function toggleAdditionalCoverages(additionalCoverages, { label, value }) {
  if (_.find(additionalCoverages, { value })) {
    return additionalCoverages.filter(({ value: _value }) => _value !== value);
  }

  return additionalCoverages.concat([{ label, value }]);
}

export function validateInsuranceType(insuranceType) {
  // TI Type is not empty
  return !_.isEmpty(insuranceType) && !_.isEmpty(insuranceType.value);
}

export function validateRegion(region) {
  // TI Type is not empty
  return !_.isEmpty(region) && !_.isEmpty(region.value);
}

export function validateDestinations(destinations) {
  // At least one value coming from suggestions
  return destinations.filter(({ isValueFromSuggestion }) => isValueFromSuggestion).length > 0;
}

export function validateTravellers(travellers) {
  // All one non-empty travellers with relationship & date of birth
  return travellers
    .filter(traveller => !_.isEmpty(traveller))
    .filter(({ relationship, dateOfBirth }) => !relationship || !dateOfBirth).length === 0;
}

export function validateStartDate(startDate, startDayLimit) {
  const startDateMoment = moment(startDate).startOf('day');
  const isValid = startDateMoment.isValid && startDateMoment >= moment().startOf('day');
  if (startDayLimit) {
    const startOfToday = moment().startOf('day');
    return isValid && startDateMoment.diff(startOfToday, 'days') <= startDayLimit;
  }
  return isValid;
}

export function validateEndDate(endDate, startDate, endDayLimit) {
  const startDateMoment = moment(startDate).startOf('day');
  const endDateMoment = moment(endDate).startOf('day');
  const isValid = endDateMoment.isValid
    && startDateMoment.isValid
    && endDateMoment >= startDateMoment;

  if (endDayLimit) {
    return isValid
      && endDateMoment.diff(startDateMoment, 'days') <= endDayLimit;
  }
  return isValid;
}

export function validateStartDateAndEndDate(startDate, endDate, startDayLimit, endDayLimit) {
  return validateStartDate(startDate, startDayLimit)
    && validateEndDate(endDate, startDate, endDayLimit);
}

// Mortgage

export function validateMortgageType(mortgageType) {
  // MG Type is not empty
  return !_.isEmpty(mortgageType);
}

export function validatePropertyType(propertyType) {
  // MG Property Type is not empty
  return !_.isEmpty(propertyType);
}

export function validateNumberWithRange(value, min, max) {
  return _.isNumber(value) && value >= min && value <= max;
}

export function validateincomeEarntHK(incomeEarntHK) {
  return _.isBoolean(incomeEarntHK);
}

export function getDestinationSpecificTips(destinationValues, tips, step) {
  const genericTips = _.get(tips, `[${step}]['DEFAULT']`, []);
  if (!destinationValues
    || destinationValues.length === 0
    || destinationValues.length > 1) return genericTips;
  const [destinationValue] = destinationValues;
  const destinationTips = _.get(tips, `[${step}][${destinationValue}]`, []);
  if (!destinationTips || destinationTips.length === 0) return genericTips;
  return destinationTips;
}
